import { type ReactElement } from 'react';
import { FavoriteToggler } from '../FavoriteToggler/FavoriteToggler';
import { logEvent } from '../Util';
import type { CameraFavoriteTogglerProps } from './Cameras.types';

export const CameraFavoriteToggler = (props: CameraFavoriteTogglerProps): ReactElement => {
    const { pageId, region } = props;

    const onFavoriteChange = (isFavorite: boolean) => {
        if (isFavorite) {
            logEvent('Camera', 'Add favorite', `Camera page id: ${pageId}`);
        } else {
            logEvent('Camera', 'Remove favorite', `Camera page id: ${pageId}`);
        }
    };
    return (
        <FavoriteToggler currentItemId={pageId.toString()} storageKey={`MyCameraPages${region.toUpperCase()}`} onFavoriteChange={onFavoriteChange} />
    );
};
